import { render, staticRenderFns } from "./OuterForm.vue?vue&type=template&id=573c56e1&scoped=true"
import script from "./OuterForm.vue?vue&type=script&lang=js"
export * from "./OuterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c56e1",
  null
  
)

export default component.exports